import { useContext } from 'react';
import ModalContext from '../ModalContext';

export default () => {
    const { activeModalId, setActiveModalId, portalTargetId } = useContext(ModalContext);

    return {
        activeModalId, setActiveModalId, portalTargetId,
    };
};
